module.exports = __webpack_public_path__ + "static/media/DM.402040c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/DM.svg
// module id = 240
// module chunks = 0